// extracted by mini-css-extract-plugin
export default {"_block":"TextSearchMarker__block__-rzlu","_marker":"TextSearchMarker__marker__69OAJ"};